import type { Moment } from 'moment';

/**
 * Adjusts a Moment date so its calendar day is not earlier than `minTime`.
 *
 * - If `data` is `null`, returns `null`.
 * - If `data` is before `minTime` on a day-granularity basis,
 *   returns a clone of `data` with its year/month/day replaced
 *   by those of `minTime` (time-of-day is preserved).
 * - Otherwise, returns a clone of `data` unchanged.
 *
 * @param data    The Moment instance from the picker (or null if cleared).
 * @param minTime The minimum Moment date that defines the earliest allowed day.
 * @returns       A Moment adjusted to be on or after `minTime`’s date, or null.
 */
export default ({ data, minTime }: { data: Moment | null; minTime: Moment }) => {
  let d = data?.clone() || null;
  if (d?.isBefore(minTime, 'day')) {
    return d.year(minTime.year()).month(minTime.month()).date(minTime.date());
  }
  return d;
};
